import { UserIcon } from '@heroicons/react/24/outline';
import { Fragment, FunctionComponent } from 'react';

/**
 * Ce composant affiche un avatar pour l'utilisateur.
 *
 * @param src - Source de l'image. Par défault `null`.
 * @param className - Classes tailwind afin d'ajuster et styliser le groupe d'étoiles. Par défaut `'rounded-full aspect-1 h-14 w-14'`.
 * @param title - Titre que l'on souhaite donner à l'avatar, ça apparait comme un titre d'image.
 */
export const Avatar: FunctionComponent<{ src?: string | null; className?: string; title?: string }> = ({
  src = null,
  className = 'rounded h-10 w-10 object-cover',
  title = '',
}) => (
  <Fragment>
    {src ? (
      <img className={`${className} object-cover`} src={src} alt={title} title={title} />
    ) : (
      <div className={`${className} bg-gray-700 flex items-center justify-center`} title={title}>
        <UserIcon className='h-6 w-6 text-white' />
      </div>
    )}
  </Fragment>
);
